/**
 * Keep track of the acceptance rate
 */
function klaroAcceptanceRate() {
    let manager = klaro.getManager();
    // We are only interested in new users / first interactions (no consent updates)
    if (manager.confirmed === true)
        return;
    manager.watch({
        update: function(manager, eventType, data) {
            if (eventType === 'saveConsents') {
                switch (data.type) {
                    case 'accept':
                        plausible('Consent Manager', {props: {action: 'Accepted'}});
                        break;
                    case 'decline':
                        plausible('Consent Manager', {props: {action: 'Declined'}});
                        break;
                    case 'save':
                        const ordered = Object.keys(data.consents).sort().reduce((obj, key) => {
                            obj[key] = data.consents[key];
                            return obj;
                        }, {});
                        const accepted = Object.keys(ordered).filter((key) => {
                            return ordered[key];
                        });
                        let details = 'Customized/Accepted[' + accepted.join() + ']';
                        plausible('Consent Manager', {props: {action: 'Customized', details: details}});
                        break;
                }
            }
        }
    });
}
document.addEventListener("DOMContentLoaded", klaroAcceptanceRate);
